import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import '../../../css/loyaltycards.css';
import '../../../css/menu.css';
import { CONFETTI_ICON } from '../../../paths/defaultImage';
import { setSessionItem } from '../../../webStorage/sessionStorage';
import LazyImage from '../../common/lazyLoad';

const MinLoyalty = ({ page }) => {
  const { t } = useTranslation();
  const doesCartBillExist =
    useSelector(
      (state) => state?.cart?.cartBill?.cart_bill && state?.cart?.cartBill?.cart_bill[0]?.value
    ) !== 0;
  const cartMinLoyaltyFromRedux = useSelector((state) => state.cart.cartBill?.amt_req_earn_loyalty);
  const cartMinLoyaltyFromRedux_text = useSelector(
    (state) => state.cart.cartBill?.amt_req_earn_loyalty_text
  );
  const currentSymbol = useSelector((state) => state.restSetting?.Setting?.curr_sym);

  const restarantLoyaltyFromRedux = useSelector(
    (state) => state.restSetting?.Setting?.loyalty_settings_v2
  );

  setSessionItem('minLoyalty', cartMinLoyaltyFromRedux);

  return (
    <>
      {cartMinLoyaltyFromRedux !== undefined && doesCartBillExist && (
        <div
          className={`d-flex justify-content-center align-items-center min-loyalty loyaltyBanner fs-13 gap-1 ${
            !!cartMinLoyaltyFromRedux ? 'promo-color' : ''
          } ${page === 'cart' && cartMinLoyaltyFromRedux === 0 ? 'display-none' : ''}`}>
          {cartMinLoyaltyFromRedux !== 0 && (
            <div className='min-loyalty-text'>
              {t('add_for')}{' '}
              <span className='fw-800'>
                {' '}
                {currentSymbol} {cartMinLoyaltyFromRedux_text}
              </span>{' '}
              {t('redeem_loyalty_cashback')}
            </div>
          )}
          {cartMinLoyaltyFromRedux === 0 && (
            <div className='d-flex gap-2 align-items-center min-loyalty-text'>
              <LazyImage src={CONFETTI_ICON} width={20} height={20}></LazyImage>
              {`${t('great_order_and')} ${restarantLoyaltyFromRedux?.cashback}% ${t(
                'loyalty_cashback'
              )}`}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default MinLoyalty;
